<div class="container py-4" style="max-width: 800px">
    @if (missing) {
        <p>This report link is not valid.</p>
    }
    @if (report) {
        <h1 class="h3">{{ report.siteName }}</h1>
        @if (report.inspection) {
            <p>{{ report.inspection.inspectionDateTime | date: 'MMM d, y h:mm a' }} · {{ report.inspection.signedName }} {{ report.inspection.signerTitle }}</p>
            @for (question of report.questions; track question.id) {
                <p><strong>{{ question.text }}</strong><br />{{ value(question) }}</p>
            }
            <p><strong>Comments</strong><br />{{ report.inspection.comments }}</p>
            @for (image of report.images; track image.id) {
                <img [src]="imageUrl(image)" [alt]="image.fileName" style="max-width: 240px" class="me-2 mb-2" />
            }
        }
        @if (report.actionItems.length) {
            <h2 class="h5">Action items</h2>
            @for (item of report.actionItems; track item.id) {
                <p>{{ item.status }} · {{ item.description }} @if (item.completedByName) { · {{ item.completedByName }} }</p>
            }
        }
    }
</div>
